import React, { createContext, useContext, useState, useMemo } from 'react';

const OverlayContext = createContext();

export const OverlayProvider = ({ children }) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);

  const value = useMemo(() =>
    ({ isOverlayOpen, setIsOverlayOpen }), [isOverlayOpen, setIsOverlayOpen]);

  return <OverlayContext.Provider value={value}>{children}</OverlayContext.Provider>;
};

export const useOverlay = () => {
  const context = useContext(OverlayContext);
  if (!context) {
    throw new Error('useOverlay must be used within an OverlayProvider');
  }
  return context;
};
